<script setup lang="ts"></script>

<template>
<svg xmlns="http://www.w3.org/2000/svg" width="248" height="43" viewBox="0 0 248 43" fill="none" class="promobox-flag absolute -top-3 -left-3" aria-hidden="true">
<path d="M3.4375 32.3723C0.9375 27.8723 -0.869801 25.5274 0.894854 19.7559L10.8874 20.1653C13.1628 20.2586 14.5395 22.7798 13.6637 24.882C12.1796 28.4445 11.4375 31.8855 11.4375 34.3723V42.8723C9.9375 41.7056 5.50248 36.0892 3.4375 32.3723Z" fill="#208664"/>
<path d="M0.0767143 22.3661L2.23304 13.4081C4.11638 5.58415 11.8225 0 20.7361 0H244.588C246.748 0 248.341 1.81289 247.837 3.69911L242.5 23.6991C242.14 25.0485 240.796 26 239.252 26H3.34196C1.21268 26 -0.373176 24.2351 0.0767143 22.3661Z" fill="#10B981"/>
</svg>
</template>

<style scoped></style>